import { Link } from 'react-router-dom';
import { CATEGORIES } from '@/data/categories';
import logo from '@/assets/logo.png';

const MAX_FOOTER_CATEGORIES = 6;

/**
 * Shared footer used across all public-facing and authenticated pages.
 * Multi-column layout with logo, navigation, categories, and account links.
 */
export function SiteFooter() {
  const visibleCategories = CATEGORIES.slice(0, MAX_FOOTER_CATEGORIES);
  const hasMore = CATEGORIES.length > MAX_FOOTER_CATEGORIES;

  return (
    <footer className="border-t border-border/30 py-10">
      <div className="container">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img src={logo} alt="Vaultsy" className="h-12 w-auto object-contain" loading="lazy" />
        </div>

        {/* Column grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-sm text-muted-foreground max-w-2xl mx-auto">
          {/* Site links */}
          <div className="flex flex-col gap-2 items-center sm:items-start">
            <h4 className="font-semibold text-foreground mb-1">Vaultsy</h4>
            <Link to="/about" className="hover:text-foreground transition-colors">About</Link>
            <Link to="/faq" className="hover:text-foreground transition-colors">FAQ</Link>
            <Link to="/explore" className="hover:text-foreground transition-colors">Explore</Link>
          </div>

          {/* Categories */}
          <div className="flex flex-col gap-2 items-center sm:items-start">
            <h4 className="font-semibold text-foreground mb-1">Categories</h4>
            {visibleCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/collections/${cat.slug}`}
                className="hover:text-foreground transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            {hasMore && (
              <Link to="/categories" className="hover:text-foreground transition-colors text-primary">
                View all →
              </Link>
            )}
          </div>

          {/* Account */}
          <div className="flex flex-col gap-2 items-center sm:items-start">
            <h4 className="font-semibold text-foreground mb-1">Account</h4>
            <Link to="/login" className="hover:text-foreground transition-colors">Sign In</Link>
            <Link to="/register" className="hover:text-foreground transition-colors">Register</Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 text-center text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Vaultsy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
